import React from 'react';

function SkeletonLine({ width = '100%', height = '16px' }) {
  return <div className="skeleton-line" style={{ width, height }} />;
}

export function SkeletonPostItem() {
  return (
    <div className="skeleton-post-item">
      <div className="skeleton-post-row">
        <div className="skeleton-post-left">
          <SkeletonLine width="24px" height="24px" />
          <div className="skeleton-post-info">
            <SkeletonLine width="55%" height="11px" />
            <SkeletonLine width="75%" height="22px" />
          </div>
        </div>
        <SkeletonLine width="64px" height="11px" />
      </div>
    </div>
  );
}

export function SkeletonArticle() {
  return (
    <div className="skeleton-article">
      <SkeletonLine width="28%" height="11px" />
      <SkeletonLine width="80%" height="44px" />
      <SkeletonLine width="110px" height="11px" />
      <div style={{ marginTop: '40px' }}>
        {[100, 92, 85, 100, 68, 96, 58, 88, 100, 74].map((w, i) => (
          <SkeletonLine key={i} width={`${w}%`} height="16px" />
        ))}
      </div>
    </div>
  );
}

export function SkeletonTableRows({ rows = 8 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="skeleton-table-row">
          <td><SkeletonLine width="180px" height="14px" /></td>
          <td><SkeletonLine width="72px" height="14px" /></td>
          <td><SkeletonLine width="56px" height="20px" /></td>
          <td><SkeletonLine width="76px" height="14px" /></td>
          <td><SkeletonLine width="110px" height="24px" /></td>
        </tr>
      ))}
    </>
  );
}
